import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { appName } from "../../../../app.json";
import { ReadData } from "../../../../providers/Patient.Provider";
import LoadingSpinner from "../../../../partials/loading";
import HealthBloodList from "./HealthBloodList";
import { LIST, CREATE, UPDATE } from "../../../../queries/health-blood.query";
import { useQuery, useMutation } from "@apollo/react-hooks";
import HealthBloodForm from "./HealthBloodForm";
import HealthBloodDetail from "./HealthBloodDetail";
import HealthBloodUpdateForm from "./HealthBloodUpdate";
import { toast } from "react-toastify";
import { CleanMessage } from "../../../../util/app";

function HealthBlood() {
    // local state
    const [newHealthBlood, setNewHealthBlood] = useState(false);
    const [healthBlood, setHealthBlood] = useState(null);
    const [uHealthBlood, setUHealthBlood] = useState(null);

    // local data
    const patient = ReadData();

    // query
    const { loading, data } = useQuery(LIST, {
        variables: {
            id: patient.lastAdmission || patient.id,
        },
        onError: (e) => toast.error(CleanMessage(e.message)),
    });

    // New
    const [PostCreateFunc, { loading: cLoading }] = useMutation(CREATE, {
        update(caches, { data: { StartHealthBloodAssessment } }) {
            const { GetHealthBloodAssessments } = caches.readQuery({
                query: LIST,
                variables: {
                    id: patient.lastAdmission || patient.id,
                },
            });
            GetHealthBloodAssessments.docs.unshift(StartHealthBloodAssessment.doc);
            caches.writeQuery({
                query: LIST,
                variables: {
                    id: patient.lastAdmission || patient.id,
                },
                data: { GetHealthBloodAssessments },
            });
        },
        onError: (e) => toast.error(CleanMessage(e.message)),
    });

    const [updateFunc, { loading: iLoading }] = useMutation(UPDATE, {
        onError: (e) => toast.error(CleanMessage(e.message)),
        onCompleted: (d) => {
            if (d.UpdateHealthBlood) {
                toast.success(d.UpdateHealthBlood.message);
                setNewHealthBlood(false);
                setHealthBlood(null);
                scrollTop();
                setUHealthBlood(null);
            }
        },
    });

    /**
     * A function that scrolls the page to top
     */
    function scrollTop() {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    }

    return (
        <>
            <Helmet>
                <title>Patient Health Blood | {appName}</title>
            </Helmet>
            <div className="row justify-content-center">
                {newHealthBlood && !healthBlood && !uHealthBlood && (
                    <div className="col md-12 fade-in">
                        <div className="card">
                            <div className="card-head">
                                <header>
                                    <button
                                        onClick={() => {
                                            setNewHealthBlood(false);
                                            setHealthBlood(null);
                                            scrollTop();
                                            setUHealthBlood(null);
                                        }}
                                        title="Back"
                                        className="mdl-button mdl-button--icon margin-right-10 mdl-button--colored"
                                    >
                                        <i className="material-icons text-primary">keyboard_backspace</i>
                                    </button>
                                    Record New Health Blood Result
                                </header>
                            </div>
                            <div className="card-body m-b-20">
                                <LoadingSpinner loading={cLoading} />
                                <HealthBloodForm
                                    onCancel={() => {
                                        setNewHealthBlood(false);
                                        setHealthBlood(null);
                                        scrollTop();
                                        setUHealthBlood(null);
                                    }}
                                    onSubmit={async (item) => {
                                        await PostCreateFunc({
                                            variables: {
                                                model: {
                                                    ...item,
                                                    admission: patient.lastAdmission,
                                                    patient: patient.id,
                                                },
                                            },
                                        });
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                )}
                {!newHealthBlood && !healthBlood && !uHealthBlood && (
                    <div className="col-md-12 fade-in">
                        <div className="card">
                            <div className="card-head">
                                <header>Health Blood</header>
                                <div className="tools">
                                    <button
                                        type="button"
                                        onClick={() => {
                                            setNewHealthBlood(true);
                                            setHealthBlood(null);
                                            scrollTop();
                                            setUHealthBlood(null);
                                        }}
                                        className="mdl-button mdl-button--icon btn-primary"
                                    >
                                        <i className="material-icons">add</i>
                                    </button>
                                </div>
                            </div>
                            <div className="card-body" style={{ minHeight: "420px" }}>
                                <LoadingSpinner loading={loading} />
                                {!loading && (
                                    <HealthBloodList
                                        className="fade-in"
                                        items={data && data.GetHealthBloodAssessments.docs}
                                        onView={(item) => {
                                            setNewHealthBlood(false);
                                            setHealthBlood(item);
                                            scrollTop();
                                            setUHealthBlood(null);
                                        }}
                                        onUpdate={(item) => {
                                            setUHealthBlood(item);
                                            setNewHealthBlood(false);
                                            setHealthBlood(null);
                                            scrollTop();
                                        }}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                )}
                {!newHealthBlood && healthBlood && !uHealthBlood && (
                    <div className="col md-12 fade-in">
                        <div className="card">
                            <div className="card-head">
                                <header>
                                    <button
                                        onClick={() => {
                                            setNewHealthBlood(false);
                                            setHealthBlood(null);
                                            scrollTop();
                                            setUHealthBlood(null);
                                        }}
                                        title="Back"
                                        className="mdl-button mdl-button--icon margin-right-10 mdl-button--colored"
                                    >
                                        <i className="material-icons text-primary">keyboard_backspace</i>
                                    </button>
                                    Recorded Health Blood List
                                </header>
                            </div>
                            <div className="card-body m-b-20">
                                {/* Detail */}
                                <HealthBloodDetail item={healthBlood} />
                            </div>
                        </div>
                    </div>
                )}
                {!newHealthBlood && !healthBlood && uHealthBlood && (
                    <div className="col md-12 fade-in">
                        <div className="card">
                            <div className="card-head">
                                <header>
                                    <button
                                        onClick={() => {
                                            setNewHealthBlood(false);
                                            setHealthBlood(null);
                                            setUHealthBlood(null);
                                            scrollTop();
                                        }}
                                        title="Back"
                                        className="mdl-button mdl-button--icon margin-right-10 mdl-button--colored"
                                    >
                                        <i className="material-icons">keyboard_backspace</i>
                                    </button>
                                    Update Health Blood
                                </header>
                            </div>
                            <div className="card-body m-b-20">
                                <LoadingSpinner loading={iLoading} />
                                <HealthBloodUpdateForm
                                    onCancel={() => {
                                        setNewHealthBlood(false);
                                        setHealthBlood(null);
                                        setUHealthBlood(null);
                                        scrollTop();
                                    }}
                                    onSubmit={async ({ comment }) => {
                                        await updateFunc({
                                            variables: {
                                                id: uHealthBlood.id,
                                                comment,
                                            },
                                        });
                                        setTimeout(() => {
                                            setNewHealthBlood(false);
                                            setHealthBlood(null);
                                            scrollTop();
                                            setUHealthBlood(null);
                                        }, 500);
                                    }}
                                    item={uHealthBlood}
                                />
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
}

export default HealthBlood;
